/* global jQuery */

/**
 * Change the button text in an accordion / collapsable component
 * according to the expanded or collapsed state.  It's a Bootstrap component
 * so it uses jQuery to listen for events.
 */
(function ($) {
  /**
   * Attach event listeners to all collapsable elements
   */
  $(document).ready(function () {
    $('.collapse').each(function () {
      const id = this.id
      $(this).on('hidden.bs.collapse', function () { more(id) })
      $(this).on('shown.bs.collapse', function () { less(id) })
    })
  })

  /**
   * Display the expanded elements and hide the collapsed elements of the
   * button associated with this collapsable item.  The elements should have
   * the same data-target attribute as the button, and have the class
   * .expanded or .collapsed.
   */
  function more (id) {
    $(`.expanded[data-target="#${id}"]`).toggleClass('d-none', true)
    $(`.collapsed[data-target="#${id}"]`).toggleClass('d-none', false)
  }

  /**
   * Disaply the collapsed elements and hide the expanded elements of the
   * button associated with this collapsable item
   */
  function less (id) {
    $(`.expanded[data-target="#${id}"]`).toggleClass('d-none', false)
    $(`.collapsed[data-target="#${id}"]`).toggleClass('d-none', true)
  }
})(jQuery)
